var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['emd-alert', '_color_danger', _vm.items.length > 0 ? 'displayFeedback' : 'hideFeedback']},[_c('ul',_vm._l((_vm.items),function(error,index){return _c('li',{key:index,staticClass:"emd-text"},[_vm._v(_vm._s(error.message))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }